var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3554 2.66785H7.44919C3.99608 2.66785 2.26953 4.3944 2.26953 7.84751V19.0701C2.26953 19.5449 2.65801 19.9334 3.13281 19.9334H14.3554C17.8085 19.9334 19.5351 18.2068 19.5351 14.7537V7.84751C19.5351 4.3944 17.8085 2.66785 14.3554 2.66785Z",
    stroke: "white",
    strokeWidth: 1.29492,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6883 7.70938L7.20789 12.1898C7.03524 12.3624 6.87122 12.6991 6.83669 12.9408L6.59497 14.6501C6.50865 15.2717 6.94028 15.7033 7.56184 15.617L9.27111 15.3753C9.51283 15.3407 9.84953 15.1767 10.0222 15.0041L14.5026 10.5237C15.2709 9.75534 15.6421 8.85753 14.5026 7.71801C13.3631 6.56985 12.4653 6.93243 11.6883 7.70938Z",
    stroke: "white",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0488 8.34821C11.4287 9.70355 12.4905 10.774 13.8545 11.1539",
    stroke: "white",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEdit);
export default __webpack_public_path__ + "static/media/message-edit.ff9ed140b0f3c21efc1c46d6abef99f8.svg";
export { ForwardRef as ReactComponent };